import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import VaTimelineSeparator from './VaTimelineSeparator.vue'

export default withConfigTransport(VaTimelineSeparator as any)
